import { useLocation } from "react-router-dom";

export function SiteFooter() {
  const location = useLocation();
  const isContact = location.pathname === "/contact";
  const isDesignProcess = location.pathname === "/design-process";

  if (location.pathname.startsWith("/portfolio")) {
    return null;
  }

  return (
    <footer className={isDesignProcess ? "footer footer--design-process" : "footer"}>
      <div className="footer-container">
        <p className="footer-text">
          {isContact
            ? "© 2026 Leon Madara. Built with passion in Nairobi, Kenya."
            : "© 2026 Leon Madara. All rights reserved."}
        </p>
      </div>
    </footer>
  );
}
